export default __webpack_public_path__ + "static/media/102design_rollup_mockup_scene003.ef04911b.png";